import { Box, Typography } from "@mui/material";

import type { Client360Stat } from "../../../helpers/types";
import { getToneStyles } from "../../shared/styles";

interface Client360StatsGridProps {
    stats: Client360Stat[];
}

export default function Client360StatsGrid({ stats }: Client360StatsGridProps) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, minmax(0, 1fr))",
                    xl: "repeat(6, minmax(0, 1fr))",
                },
                gap: 1.1,
            }}
        >
            {stats.map((stat) => (
                <Box
                    key={stat.label}
                    sx={{
                        p: 1.2,
                        borderRadius: 3,
                        minHeight: 122,
                        minWidth: 0,
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textAlign: "center",
                        ...getToneStyles(stat.tone),
                    }}
                >
                    <Typography
                        variant="overline"
                        sx={{ letterSpacing: "0.12em", textAlign: "center", width: "100%", display: "block" }}
                    >
                        {stat.label}
                    </Typography>
                    {stat.sublabel ? (
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block", mt: 0.35, fontWeight: 700, textAlign: "center", width: "100%" }}
                        >
                            {stat.sublabel}
                        </Typography>
                    ) : null}
                    <Typography
                        sx={{
                            fontWeight: 800,
                            fontSize: { xs: "1.05rem", sm: "1.12rem", xl: "1.2rem" },
                            lineHeight: 1.2,
                            whiteSpace: "normal",
                            maxWidth: "100%",
                            overflowWrap: "anywhere",
                            wordBreak: "break-word",
                            hyphens: "auto",
                            textAlign: "center",
                            width: "100%",
                            mt: stat.sublabel ? 0.25 : 0,
                        }}
                    >
                        {stat.value}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            opacity: 0.92,
                            lineHeight: 1.55,
                            whiteSpace: "normal",
                            maxWidth: "100%",
                            overflowWrap: "anywhere",
                            wordBreak: "break-word",
                            hyphens: "auto",
                            textAlign: "center",
                            width: "100%",
                        }}
                    >
                        {stat.helper}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}
